import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";


// Get Table Data
export const STPMPCBTestTableDataAPI = createAsyncThunk("STPMPCBTestTableData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        handleSTPMPCBTestExport
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MPCBTest_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleSTPMPCBTestExport && handleSTPMPCBTestExport()
                return result.data

            } else {
                return result
            }
        })
})

const STPMPCBTestTableDataSlice = createSlice({
    name: "STPMPCBTestTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMPCBTestTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMPCBTestTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMPCBTestTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMPCBTestTableDataReducer = STPMPCBTestTableDataSlice.reducer

export const STPMPCBTestExportDataAPI = createAsyncThunk("STPMPCBTestExportData", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        M_UserID,
        Flag,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_STP_T_STP_MPCBTest_Select?FromDate=${FromDate ? FromDate : ''}&ToDate=${ToDate ? ToDate : ''}&M_WardID=${M_WardID ? M_WardID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}&Flag=${Flag}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const STPMPCBTestExportDataSlice = createSlice({
    name: "STPMPCBTestExportData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMPCBTestExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(STPMPCBTestExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(STPMPCBTestExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const STPMPCBTestTableExportDataReducer = STPMPCBTestExportDataSlice.reducer


export const STPMPCBTestPostDataAPI = createAsyncThunk("STPMPCBTestPostData", async ({ data }) => {
    const {
        T_STP_MPCBTestID,
        ResultValue,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("T_STP_MPCBTestID", T_STP_MPCBTestID);
    formdata.append("ResultValue", ResultValue);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/Post_WEB_STP_T_STP_MPCBTest_Update`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const STPMPCBTestPostDataSlice = createSlice({
    name: "STPMPCBTestPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMPCBTestPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(STPMPCBTestPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(STPMPCBTestPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMPCBTestPostDataReducer = STPMPCBTestPostDataSlice.reducer

// -----------------Delete API ---------------

export const STPMPCBTestDeleteAPI = createAsyncThunk("STPMPCBTestDelete", async ({ data }) => {
    const {
        T_STP_MPCBTestID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("T_STP_MPCBTestID", T_STP_MPCBTestID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/APKDashboard/WEB_STP_T_STP_MPCBTest_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const STPMPCBTestDeleteSlice = createSlice({
    name: "STPMPCBTestDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(STPMPCBTestDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(STPMPCBTestDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(STPMPCBTestDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const STPMPCBTestDeleteReducer = STPMPCBTestDeleteSlice.reducer